export const SIDEBAR_COLLAPSED_COOKIE_NAME = 'sidebar-collapsed'

const SIDEBAR_PREFERENCE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

export function parseSidebarCollapsedPreference(value: string | undefined): boolean {
  if (value === 'false') return false
  if (value === 'true') return true

  return true
}

export function serializeSidebarCollapsedPreference(collapsed: boolean, secure: boolean): string {
  const secureAttribute = secure ? '; Secure' : ''

  return `${SIDEBAR_COLLAPSED_COOKIE_NAME}=${String(collapsed)}; Path=/; Max-Age=${SIDEBAR_PREFERENCE_MAX_AGE_SECONDS}; SameSite=Lax${secureAttribute}`
}

/** Migrates the preference written by PR #892 before any sidebar markup can paint. */
export function getSidebarPreferenceMigrationScript(): string {
  const cookieName = JSON.stringify(SIDEBAR_COLLAPSED_COOKIE_NAME)
  const maxAge = JSON.stringify(SIDEBAR_PREFERENCE_MAX_AGE_SECONDS)

  return `(function(){try{var name=${cookieName};var hasCookie=document.cookie.split('; ').some(function(row){return row.indexOf(name+'=')===0});if(hasCookie){localStorage.removeItem(name);return}var stored=localStorage.getItem(name);if(stored!=='true'&&stored!=='false')return;var secure=location.protocol==='https:'?'; Secure':'';document.cookie=name+'='+stored+'; Path=/; Max-Age='+${maxAge}+'; SameSite=Lax'+secure;var migrated=document.cookie.split('; ').some(function(row){return row.indexOf(name+'=')===0});if(migrated){localStorage.removeItem(name);document.documentElement.style.visibility='hidden';setTimeout(function(){document.documentElement.style.visibility=''},5000);location.reload()}}catch{}})()`
}
